import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./IconTooltip.module.scss";

interface IconTooltipProps {
  title: string;
  icon?: React.ReactNode | undefined;
  css?: string | undefined;
}

const IconTooltip: React.FC<IconTooltipProps> = ({ title, icon, css }) => {
  return (
    <Tooltip title={title} disableInteractive arrow>
      <IconButton className={`${styles.iconTooltip} ${css ?? ""}`}>{icon ?? <InfoOutlinedIcon />}</IconButton>
    </Tooltip>
  );
};

export default IconTooltip;
